import script from "./EditTeacher.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTeacher.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__